export default {
    detail: true,
    labelWidth: 80,
    labelPosition: 'left',
    column: [{
            label: '姓名',
            prop: 'name',
            bind: "basisArchivePersonalData.name",
            span: 6,
        },
        {
            label: "性别",
            prop: "gender",
            bind: 'basisArchivePersonalData.gender',
            formslot: true,
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'sex'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 6
        },
        {
            label: '出生年月',
            prop: 'birthday',
            bind: 'basisArchivePersonalData.birthday',
            span: 6
        },
        {
            label: '爱好',
            prop: 'hobby',
            bind: 'basisArchivePersonalData.hobby',
            span: 6
        },
        {
            label: '籍贯',
            prop: 'nativePlace',
            bind: 'basisArchivePersonalData.nativePlace',
            span: 6
        },
        {
            label: '电话',
            prop: 'contact',
            bind: 'basisArchivePersonalData.contact',
            span: 6
        },
        {
            label: '健康情况',
            prop: 'healthyState',
            bind: 'basisArchivePersonalData.healthyState',
            span: 6,
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'healthy'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            }
        },{
            label: '优先级',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'priority'
            },
            formatter: (row, value, label, column) => {
                return label
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            dataType: 'number',
            prop: "priority",
            bind: 'basisArchivePersonalData.priority',
            span: 6,
        },
        {
            label: "身份证号",
            prop: "cardNo",
            bind: 'basisArchivePersonalData.cardNo',
            span: 24
        },
        {
            label: "照片",
            prop: "photoUrl",
            bind: 'basisArchivePersonalData.photoUrl',
            span: 8,
            formslot: true,
        },
        {
            labelWidth: 0,
            prop: 'info',
            span: 16,
            formslot: true
        },
        {
            label: '身高',
            prop: "height",
            bind: 'basisArchivePersonalData.height',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'height'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 8,
        },
        {
            label: '体重',
            prop: "weight",
            bind: 'basisArchivePersonalData.weight',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'weight'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 8,
        },
        {
            label: '性格',
            prop: "byCharacter",
            bind: 'basisArchivePersonalData.byCharacter',
            type:'select',
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'character'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 8,
        },
        // {
        //     label: '户籍地址',
        //     prop: 'residenceAddress',
        //     bind: 'basisArchivePersonalData.residenceAddress',
        //     formslot: true,
        //     span: 24,
        //     row: true
        // },
        // {
        //     label: '现住地址',
        //     prop: 'actualResidentialAddress',
        //     bind: 'basisArchivePersonalData.actualResidentialAddress',
        //     span: 24,
        //     formslot: true,
        //     row: true
        // },
        {
            label: '就学情况',
            prop: 'studentStatus',
            bind: 'basisArchivePersonalData.studentStatus',
            formslot: true,
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'Academic_status'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 24,
            row: true
        },
        {
            label: '学习经历',
            prop: 'studyExperience',
            bind: 'basisArchivePersonalData.studyExperience',
            // type: 'textarea',
            span: 24,
            row: true
        },
        {
            label: '家庭照料情况',
            prop: "employmentStatus",
            bind: 'basisArchivePersonalData.employmentStatus',
            type: "select",
            dataType: "number",
            dicData: [{
                label: '是否无人照顾',
                value: 0
            }, {
                label: '是否他人照顾',
                value: 1
            }],
            formslot: true,
            span: 24,
            row: true
        },
        {
            label: '青少年类型',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'Five-youth_types'
            },
            formatter: (row, value, label, column) => {
                return label
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            dataType: 'number',
            prop: "teenagersType",
            bind: 'basisArchivePersonalData.teenagersType',
            span: 24,
            row:true
        },
        {
            label: '家庭类型',
            prop: 'householdType',
            bind: 'basisArchivePersonalData.householdType',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'household_type'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 8,
        },
        {
            label: '家庭教养',
            prop: 'familyUpbringing',
            bind: 'basisArchivePersonalData.familyUpbringing',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'parenting_pattern'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 8,
        },
        {
            label: '家庭经济',
            prop: 'familyEconomy',
            bind: 'basisArchivePersonalData.familyEconomy',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'Family-economic_status'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 8,
        }, {
            label: '家庭经济备注',
            prop: 'familyNote',
            bind: 'basisArchivePersonalData.familyNote',
            span: 24,
            row: true
        },
        {
            label: '综合特质',
            prop: 'comprehensive',
            bind: 'basisArchivePersonalData.comprehensive',
            // type: 'textarea',
            span: 24,
            row: true
        }, {
            label: '曾使用相关服务记录',
            prop: 'isServiceSituation',
            bind: 'basisArchivePersonalData.isServiceSituation',
            formslot: true,
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'yes_no'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 24,
            row: true
        },
        {
            label: '现使用相关服务记录',
            prop: 'serviceSituationRecord',
            bind: 'basisArchivePersonalData.serviceSituationRecord',
            formslot: true,
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'yes_no'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 24,
            row: true
        }, {
            label: '跟踪走访记录',
            prop: 'basisArchiveInterviewList',
            span: 24,
            formslot: true,
            row: true
        }, {
            label: '情绪问题',
            prop: 'emotionalProblems',
            bind: 'basisArchiveProblem.emotionalProblems',
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            type: 'select',
            dicQuery: {
                code: 'emotional'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,

        },
        {
            label: '家庭暴力问题',
            prop: 'domesticViolence',
            bind: 'basisArchiveProblem.domesticViolence',
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            type: 'select',
            dicQuery: {
                code: 'family_violence'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,

        }, {
            label: '家庭照料情况',
            prop: 'employmentService',
            bind: 'basisArchiveProblem.employmentService',
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            type: 'select',
            dicQuery: {
                code: 'employment_service'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,

        }, {
            label: '院舍庇护需求',
            prop: 'arranging',
            bind: 'basisArchiveProblem.arranging',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'yes_no'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,

        },
        {
            label: '是否司法矫正、安置帮教',
            prop: 'judicialPlacement',
            bind: 'basisArchiveProblem.judicialPlacement',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'yes_no'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,

        },
        {
            label: '外宿居住需求',
            prop: 'housingArrangement',
            bind: 'basisArchiveProblem.housingArrangement',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'housing_situation'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true
        },

        {
            label: '行为问题',
            prop: 'behaviorProblems',
            bind: 'basisArchiveProblem.behaviorProblems',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'yes_no'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        },
        {
            label: '儿童照顾',
            prop: 'childCare',
            bind: 'basisArchiveProblem.childCare',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'yes_no'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        }, {
            label: '婚恋问题',
            prop: 'marriageProblems',
            bind: 'basisArchiveProblem.marriageProblems',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'yes_no'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        },
        {
            label: '健康问题',
            prop: 'healthProblems',
            bind: 'basisArchiveProblem.healthProblems',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'healthy'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        },
        {
            label: '学习问题',
            prop: 'learningProblems',
            bind: 'basisArchiveProblem.learningProblems',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'yes_no'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        },

        {
            label: '经济援助',
            prop: 'financialAid',
            bind: 'basisArchiveProblem.financialAid',
            type: "select",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'yes_no'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        },
        {
            label: '不良嗜好',
            prop: 'badAddiction',
            bind: 'basisArchiveProblem.badAddiction',
            type: "checkbox",
            dicUrl: '/api/blade-system/dict-biz/dictionary',
            dicQuery: {
                code: 'bad_hobby'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,

        }, {
            label: "是否有纹身",
            prop: "tattoo",
            bind: 'basisArchiveProblem.tattoo',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'there_tattoo'
            },
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "是否有打架经历",
            prop: "fightExperience",
            bind: 'basisArchiveProblem.fightExperience',
            type: "checkbox",
            dataType: "number",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'fighting_experience'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "是否经常出入娱乐场所",
            prop: "entertainmentVenues",
            bind: 'basisArchiveProblem.entertainmentVenues',
            type: "checkbox",
            dataType: "number",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'entertainment_place'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "是否夜不归宿行为",
            dataType: "number",
            prop: "nightOut",
            bind: 'basisArchiveProblem.nightOut',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'nocturnal_behavior'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "作息时间",
            prop: "workTime",
            dataType: "number",
            bind: 'basisArchiveProblem.workTime',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'time_Table'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "是否有犯罪前科",
            dataType: "number",
            prop: "criminalRecord",
            bind: 'basisArchiveProblem.criminalRecord',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'criminal_record'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "是否喜欢网络游戏",
            dataType: "number",
            prop: "isOnlineGame",
            bind: 'basisArchiveProblem.isOnlineGame',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'network_game'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "在校处分情况",
            dataType: "number",
            prop: "isDisciplinary",
            bind: 'basisArchiveProblem.isDisciplinary',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'punishment'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "是否有旷课行为",
            dataType: "number",
            prop: "isTruancy",
            bind: 'basisArchiveProblem.isTruancy',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'absenteeism'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "法律法规认知程度",
            dataType: "number",
            prop: "isRegulations",
            bind: 'basisArchiveProblem.isRegulations',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'awareness-laws_regulations'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "政策咨询",
            dataType: "number",
            prop: "policyConsultation",
            bind: 'basisArchiveProblem.policyConsultation',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'yes_no'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
        }, {
            label: "其他",
            dataType: "number",
            prop: "other",
            bind: 'basisArchiveProblem.other',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'yes_no'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 24,
            row: true,
            formslot: true,
        },
        {
            label: "颜色标注",
            dataType: "number",
            prop: "classification",
            bind: 'basisArchiveProblem.classification',
            type: "checkbox",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'Color'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 24,
            row: true,
            formslot: true,
        },
        {
            label: '亲属关系',
            prop: 'basisArchiveKinshipList',
            span: 24,
            formslot: true,
            row: true
        },
        {
            label: '人际关系',
            prop: 'basisArchiveRelationList',
            span: 24,
            formslot: true,
            row: true
        },

        {
            label: '主动需求/问题摘要',
            prop: 'problemSummary',
            bind: 'basisArchiveProblem.problemSummary',
            span: 24,
            row: true
        },
        {
            label: '需求跟进',
            prop: 'needTo',
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'yes_no'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 24,
            row: true,
            formslot: true
        },
        {
            label: '当事人是否愿意接收服务',
            prop: 'isWilling',
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'yes_no'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        },
        {
            labelWidth: 0,
            prop: 'tb',
            span: 12,
            formslot: true
        },
        {
            label: '个案是否跟进',
            prop: 'isFollowUp',
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'yes_no'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            span: 12,
            formslot: true,
        },
        {
            label: '个案来源',
            prop: 'source',
            dataType: 'number',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
                code: 'individual_case'
            },
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            formslot: true,
            span: 12
        },
        {
            label: '督导备注',
            prop: 'supervisionRemark',
            span: 12
        },
        {
            labelWidth: 0,
            prop: 'dd',
            span: 12,
            formslot: true
        },
    ]
}
